<template>
  <div class="flex flex-col gap-l">
    <div v-for="group in 2" :key="group" class="flex flex-col gap-s">
      <Skeleton class="h-5 w-32 rounded" />
      <Skeleton v-for="row in 8" :key="row" class="h-10 w-full rounded" />
    </div>
  </div>
</template>